const form = {
  formId: "new-user-form",
  formField: {
    email: {
      name: "email",
      label: "Email Address",
      type: "email",
      errorMsg: "Email address is required.",
      invalidMsg: "Your email address is invalid",
    },
    password: {
      name: "password",
      label: "Password",
      type: "password",
      errorMsg: "Password is required.",
      invalidMsg: "Your password should be more than 8 characters.",
    },
    repeatPassword: {
      name: "repeatPassword",
      label: "Repeat Password",
      type: "password",
      errorMsg: "Password is required.",
      invalidMsg: "Your password doesn't match.",
    },
    firstname: {
      name: "firstname",
      label: "First Name",
      type: "text",
      errorMsg: "First name is required.",
    },
    lastname: {
      name: "lastname",
      label: "Last Name",
      type: "text",
      errorMsg: "Last name is required.",
    },
    role: {
      name: "role",
      label: "Role",
      type: "select",
      options: [
        { value: "ADMIN", label: "Admin" },
        { value: "USER", label: "User" },
      ],
      errorMsg: "Role is required.",
    },
  },
};

export default form;
